var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", [
    _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "iconColumn" }),
        _vm._v(" "),
        _c("th", { staticClass: "nameColumn" }, [
          _vm._v("\n\t\t\t\t" + _vm._s(_vm.t("radio", "Name")) + "\n\t\t\t")
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "actionColumn" })
      ])
    ]),
    _vm._v(" "),
    _c(
      "tbody",
      [
        !_vm.isFolder
          ? _vm._l(_vm.stationData, function(station, idx) {
              return _c(
                "tr",
                { key: idx, class: { selected: idx === _vm.activeItem } },
                [
                  _c(
                    "td",
                    {
                      on: {
                        click: function($event) {
                          return _vm.doPlay(idx, station)
                        }
                      }
                    },
                    [
                      _c("blur-hash-image", {
                        staticClass: "stationIcon",
                        attrs: {
                          width: "32",
                          height: "32",
                          hash:
                            station.blurHash || "L1TSUA?bj[?b~qfQfQj[ayfQfQfQ",
                          src: station.favicon
                        }
                      }),
                      _vm._v(" "),
                      _c("span", {
                        class: { "icon-starred": _vm.isFavorite(station) }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticClass: "nameColumn",
                      on: {
                        click: function($event) {
                          return _vm.doPlay(idx, station)
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "innernametext" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(station.name) +
                            "\n\t\t\t\t\t"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "actionColumn" },
                    [
                      _c(
                        "Actions",
                        [
                          !_vm.isFavorite(station)
                            ? _c(
                                "ActionButton",
                                {
                                  attrs: {
                                    icon: "icon-star",
                                    "close-after-click": true
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.doFavor(idx, station)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.t("radio", "Add to favorites")
                                      ) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isFavorite(station)
                            ? _c(
                                "ActionButton",
                                {
                                  attrs: {
                                    icon: "icon-star",
                                    "close-after-click": true
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.doFavor(idx, station)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.t("radio", "Remove from favorites")
                                      ) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "ActionButton",
                            {
                              attrs: {
                                icon: "icon-info",
                                "close-after-click": true
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toggleSidebar(station)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.t("radio", "Details")) +
                                  "\n\t\t\t\t\t\t"
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.isFolder
          ? _vm._l(_vm.stationData, function(station, idx) {
              return _c(
                "tr",
                {
                  key: idx,
                  on: {
                    click: function($event) {
                      return _vm.changeRoute(station.path)
                    }
                  }
                },
                [
                  _vm._m(0, true),
                  _vm._v(" "),
                  _c("td", { staticClass: "nameColumn" }, [
                    _c("span", { staticClass: "innernametext" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t" + _vm._s(station.name) + "\n\t\t\t\t\t"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "actionColumn" })
                ]
              )
            })
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("span", { staticClass: "icon-folder" })])
  }
]
render._withStripped = true

export { render, staticRenderFns }